<template>
  <div class="container pt-4">
    <h1 style="text-align: center">Služby</h1>
    <div class="row pt-4 icons">
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Mapy zdarma</h4>
            <i class="fa fa-map fa-4x"></i>
            <p class="card-text pt-2">
              zdarma poskytneme mapy a informační turistické materiály
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Vyjíždky na koních</h4>
            <i class="fa fa-horse-head fa-4x"></i>
            <p class="card-text pt-2">vyjížďky na koních v místě a okolí</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Úschovna lyží a kol</h4>
            <i class="fa fa-skiing-nordic fa-4x"></i>
            <p class="card-text pt-2">
              bezplatné uložení lyžařské výstroje, kol i cestovních zavazadel v den odjezdu
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Rádi poradíme</h4>
            <i class="fa fa-smile-beam fa-4x"></i>
            <p class="card-text pt-2">
              poskytnutí rady při výběru turistické stezky a cyklostezky
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Wifi</h4>
            <i class="fa fa-wifi fa-4x"></i>
            <p class="card-text pt-2">
              v penzionu je WIFI zdarma
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Půjčovna kol</h4>
            <i class="fa fa-bicycle fa-4x"></i>
            <p class="card-text pt-2">
              v obci je v letní sezóně půjčovna elektro kol, v zimní půjčovna
              lyží
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Památky</h4>
            <i class="fa fa-landmark fa-4x"></i>
            <p class="card-text pt-2">
              rádi vás informujeme o památkách v okolí
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Parkoviště</h4>
            <i class="fa fa-parking fa-4x"></i>
            <p class="card-text pt-2">
              součástí penzionu je venkovní parkoviště až pro 5 automobilů
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Sportovní a turistické služby</h2>
            <ul>
              <li>zdarma jsou k dispozici mapy a informační turistické materiály v letákové i knižní podobě</li>
              <li>vyjížďky na koních v místě a okolí</li>
              <li>bezplatné uložení lyžařské výstroje, kol i např. cestovních zavazadel v den odjezdu po odhlášení z ubytování</li>
              <li>poskytnutí rady při výběru turistické stezky a cyklostezky</li>
              <li>doporučení na výlety k pamětihodnostem i ve vzdálenějším okolí (pro výlety autem)</li>
              <li>v obci je v letní sezóně půjčovna elektro kol, v zimní půjčovna lyž</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "services",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icons .card-body {
  text-align:center;
}
</style>
